<template>
  <GiscubeLayout v-if="toolsLoaded">
    <slot />
  </GiscubeLayout>
</template>

<script>
import { GiscubeLayout } from '@giscube/geoportal'

export default {
  name: 'BasicLayout',
  components: { GiscubeLayout },
  data () {
    return {
      toolsLoaded: false
    }
  },
  created () {
    this.fetchMapTools()
  },
  computed: {
    accessToken () {
      return this.$store.state.auth.accessToken
    }
  },
  methods: {
    fetchMapTools () {
      this.$store.dispatch('layout/fetchMapTools', this).then(() => {
        this.toolsLoaded = true
      }).catch(error => {
        this.toolsLoaded = true
        this.$except(error)
      })
    }
  },
  watch: {
    accessToken (newToken, oldToken) {
      if (newToken !== oldToken) {
        this.fetchMapTools()
      }
    }
  }
}
</script>
